import {err, ok, ValidationError} from 'framework';
import type {Result, Validator} from 'framework';
import * as z from 'zod';
import type {WorkoutTemplateId} from '../../domain/workout-template-id.value-object';

export class WorkoutTemplateIdValidator implements Validator<WorkoutTemplateId> {
  readonly standardSchema = z.templateLiteral(['wtp', '_', z.string().min(1)]);

  validate(value: unknown): Result<WorkoutTemplateId, ValidationError> {
    const parsed = this.standardSchema.safeParse(value);
    if (!parsed.success) {
      return err(
        new ValidationError(
          parsed.error.issues[0]?.message ?? 'Invalid workout template id.',
        ),
      );
    }
    return ok(parsed.data);
  }
}
